import React from 'react';
import { View } from 'react-native';
import Typography from 'src/components/Text/Text';
import Button from 'src/components/Button/Button';
import Divider from 'src/components/Divider/Divider';
import AmountSelector from './AmountSelector';
import { styles } from '../screens/Insurance/InsuranceScreen.styles';

interface MotorTruckCargoProps {
  limit: number;
  setLimit: (value: number) => void;
  deductible: {
    value: number;
    set: (value: number) => void;
  };
  isProducer: boolean;
  reeferBreakdown: {
    value: 'opt-in' | 'opt-out';
    set: (value: 'opt-in' | 'opt-out') => void;
    limit: number;
    setLimit: (value: number) => void;
    deductible: {
      value: number;
      set: (value: number) => void;
    };
  };
}

const MotorTruckCargo: React.FC<MotorTruckCargoProps> = ({
  limit,
  setLimit,
  deductible,
  isProducer,
  reeferBreakdown,
}) => (
  <View style={styles.switchSectionsCardContents}>
    <AmountSelector
      label="Motor Truck Cargo Limit"
      description="How much coverage would you like for Motor Truck Cargo?"
      presets={[100000, 150000, 250000]}
      value={limit}
      onChange={setLimit}
      testIDPrefix="motor-truck-cargo-limit"
    />
    <AmountSelector
      label="Deductible"
      presets={[1000, 2500, 5000]}
      value={deductible.value}
      onChange={deductible.set}
      testIDPrefix="motor-truck-cargo-deductible"
    />

    {isProducer && (
      <>
        <Divider />
        <Typography variant="title2">Reefer Breakdown (Refrigerated Goods)</Typography>
        <View style={styles.buttonGroupContainer}>
          {(['opt-out', 'opt-in'] as const).map((value) => (
            <Button
              testID={`motor-truck-cargo-reefer-breakdown-${value}`}
              key={value}
              title={value === 'opt-out' ? 'Opt-Out' : 'Opt-In'}
              type={reeferBreakdown.value === value ? 'secondary' : 'tertiary'}
              onPress={() => reeferBreakdown.set(value)}
              style={styles.switchButton}
            />
          ))}
        </View>
        {reeferBreakdown.value === 'opt-in' && (
          <>
            <AmountSelector
              label="Reefer Breakdown Limit"
              description="How much coverage would you like for reefer breakdown?"
              presets={[50000, 100000, 150000]}
              value={reeferBreakdown.limit}
              onChange={reeferBreakdown.setLimit}
              testIDPrefix="motor-truck-cargo-reefer-limit"
            />
            <AmountSelector
              label="Reefer Breakdown Deductible"
              presets={[1000, 2500, 5000]}
              value={reeferBreakdown.deductible.value}
              onChange={reeferBreakdown.deductible.set}
              testIDPrefix="motor-truck-cargo-reefer-deductible"
            />
          </>
        )}
      </>
    )}
  </View>
);

export default MotorTruckCargo;
